import { Label } from "components/label"
import { CollapsibleSection } from "../../../../../../components/collapsibleSection"
import Input from "components/input"
import { UseFormReturn } from "react-hook-form";
import { ICreateOrgForm } from "interfaces";
import { HttpError } from "@refinedev/core";

export const OwnerAccountSection = (props: UseFormReturn<ICreateOrgForm, HttpError, ICreateOrgForm>) => {
  const { register, formState: { errors }} = props;
  return (
    <CollapsibleSection label="Owner account information">
      <div className="divide-y divide-gray-100">
        <div className="px-4 py-6 sm:px-6">
          <div className="grid gap-x-4 gap-y-6 sm:grid-cols-6 lg:gap-x-6">
            <div className="sm:col-span-3">
              <Label 
                required
                id="owner_email" 
                name="Owner email"  
              />
              <Input 
                id="owner_email"
                type="text"
                placeholder="Owner email"
                error={errors["account"]?.email}
                {...register("account.email")}
              />
              {errors["account"]?.email ? ( 
                <p className="error-text">
                  <span className="font-medium">
                    {errors["account"]?.email.message}
                  </span>
                </p> 
              ): null}
            </div>
            <div className="sm:col-span-3">
              <Label 
                required
                id="role_aname" 
                name="Role name"  
              />
              <Input 
                disabled
                id="role_aname"
                type="text"
                value="Owner"
                placeholder="Role name"
              />
            </div>
            <div className="sm:col-span-3">
              <Label 
                required
                id="first_name" 
                name="First name"
              />
              <Input 
                id="first_name"
                type="text"
                placeholder="First name"
                error={errors["account"]?.first_name}
                {...register("account.first_name")}
              />
              {errors["account"]?.first_name ? ( 
                <p className="error-text">
                  <span className="font-medium">
                    {errors["account"]?.first_name.message}
                  </span>
                </p> 
              ): null}
            </div>
            <div className="sm:col-span-3">
              <Label 
                required
                id="last_name" 
                name="Last name"  
              />
              <Input 
                id="last_name"
                type="text"
                placeholder="Last name"
                error={errors["account"]?.last_name}
                {...register("account.last_name")}
              />
              {errors["account"]?.last_name ? ( 
                <p className="error-text">
                  <span className="font-medium">
                    {errors["account"]?.last_name.message}
                  </span>
                </p> 
              ): null}
            </div>
          </div>
        </div>
      </div>
    </CollapsibleSection>
  )
}